
export class SwitcherScene extends Phaser.Scene {
    ID: number;
    nextScene: string;
    currentScene: string;

  constructor() {
    super({
      key: "SwitcherScene"
    });

  }

    // Data that is passed in from MenuScene
    init(data): void {
        this.nextScene = data.next;
    }

    preload(): void {
        this.load.image("button", require("/src/assets/qci/sprites/buttons/square-button-red.png"));
  }

    create(): void {
        // Title of the scene
        this.add.text(0, 0, this.nextScene);

        // Menu button
        let menu = this.add.image(700, 100, "button");
        menu.setInteractive();
        menu.setDisplaySize(100, 100);
        menu.setDepth(20);

        // Menu text
        let txt = this.add.text(685, 100, "Menu");
        txt.setDepth(20);

        // Menu onClick: put the current scene to sleep and start menu scene again
        // Note: the games WILL save their state since we are just continuously sleeping/waking them
        menu.on('pointerdown', () => {
            console.warn("Putting " + this.nextScene + " to sleep and starting MenuScene");
            this.scene.sleep(this.currentScene);
            this.scene.start("MenuScene");
            this.currentScene = "MenuScene";
        });

         // Some Notes:
         // this.scene.start() shuts down current scene and starts a new one (will overlap the same scene over and over again so need to check for activity)
         // this.scene.launch() runs the new scene in parallel (overlaps the contents of both scenes...probably not wanted)
         // this.scene.switch() puts current scene to sleep and starts new one

        // If the next scene doesn't exist (not sleeping) then launch a new scene for it 
        if (!this.scene.isSleeping(this.nextScene)) {
            this.scene.launch(this.nextScene);
            // Set the camera so it's a smaller version of the scene (so that we don't cover the menu button)
            let cam = this.scene.get(this.nextScene).cameras.main;
            cam.zoom = 0.5;
            this.currentScene = this.nextScene;
        }
        // Else, wake up the sleeping scene instead of launching a new one
        else {
            this.scene.wake(this.nextScene);
            this.currentScene = this.nextScene;
        }
  
  }


  update(): void {
   
  }

}



// WEBPACK FOOTER //
// ./src/games/demos/phaserMultiSceneDemo/scenes/switcherScene.ts